import {AsyncThunk, createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'

export type RequestStatus = 'idle' | 'loading' | 'failed'

const create = (redux_name: string, initialState: {
    [key: string]: any
}, reducers: {
    [key: string]: (state: any, args: PayloadAction<any>) => void
}, async_reducers: {
    [key: string]: (...args: any[]) => Promise<any>
}) => {
    for (const key in async_reducers) {
        const async_reducer = async_reducers[key]

        // @ts-ignore
        async_reducers[key] = createAsyncThunk(
            `${redux_name}/${key}`,
            async function (args: any, thunkAPI) {
                // @ts-ignore
                return await async_reducer(thunkAPI.getState()[redux_name], args)
            }
        )
    }

    const dashboardSlice = createSlice({
        name: redux_name,
        initialState,
        reducers: reducers,
        extraReducers: (builder) => {
            for (const key in async_reducers) {
                const async_reducer = async_reducers[key] as any
                builder
                    .addCase(async_reducer.fulfilled, (state, action) => {
                        for (const payloadKey in action.payload) {
                            state[payloadKey] = action.payload[payloadKey]
                        }
                    })
            }
        }
    })

    return {
        reducer: dashboardSlice.reducer,
        actions: {
            ...dashboardSlice.actions,
            ...async_reducers
        } as {
            [key: string]: any
        }
    }
}

export default create